import { useMemo } from 'react';

export const useTextMeasurer = (font = '12px sans-serif') => {
    const canvas = useMemo(() => document.createElement('canvas'), []);
    const ctx = useMemo(() => canvas.getContext('2d'), [canvas]);

    const measure = text => {
        if (!ctx) return 0; // jsdom/tests: no canvas context
        ctx.font = font;
        return ctx.measureText(text).width;
    };

    const truncate = (text, maxWidth) => {
        if (measure(text) <= maxWidth) return text;
        let truncated = text;
        while (truncated.length > 0 && measure(truncated + '…') > maxWidth) {
            truncated = truncated.slice(0, -1);
        }
        return truncated + '…';
    };

    return truncate;
};
